import { render, staticRenderFns } from "./AccordionJan.vue?vue&type=template&id=29fe5ea4&"
import script from "./AccordionJan.vue?vue&type=script&lang=js&"
export * from "./AccordionJan.vue?vue&type=script&lang=js&"
import style0 from "./AccordionJan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports